import { render, staticRenderFns } from "./wajue-result.vue?vue&type=template&id=7623ffa6&scoped=true&"
import script from "./wajue-result.vue?vue&type=script&lang=ts&"
export * from "./wajue-result.vue?vue&type=script&lang=ts&"
import style0 from "./wajue-result.vue?vue&type=style&index=0&id=7623ffa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7623ffa6",
  null
  
)

export default component.exports